import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Delete Sweep"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-delete-sweep',
    templateUrl: './icon-delete-sweep.component.html',
    styleUrls: ['./icon-delete-sweep.component.scss'],
    standalone: false
})
export class IconDeleteSweepComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
